import { render } from "./customer-blacklist-check.vue?vue&type=template&id=2e1046d2"
import script from "./customer-blacklist-check.vue?vue&type=script&lang=js"
export * from "./customer-blacklist-check.vue?vue&type=script&lang=js"

import exportComponent from "/Users/newuser/Herd/spider-project-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__